import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "content"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedValue = this.selectTarget.value

    this.contentTargets.forEach((content) => {
      const contentValue = content.dataset.value

      if (contentValue === selectedValue) {
        content.classList.remove('d-none')
      } else {
        content.classList.add('d-none')
      }
    })
  }
}
